export function RefundPage() {
  return (
    <article className="legal-document">
      <h1>Política de Cancelamento e Reembolso</h1>
      <p className="text-muted">
        LONDON SIM GESTÃO DE DOCUMENTOS LTDA (Datasci Editora) — CNPJ 22.390.588/0001-70
        <br />
        Em conformidade com a Lei nº 8.078/1990 (Código de Defesa do Consumidor).
      </p>

      <section>
        <h2>1. Direito de Arrependimento (Art. 49 do CDC)</h2>
        <p>
          Em conformidade com o artigo 49 da Lei nº 8.078/1990 (Código de Defesa do Consumidor), nas compras efetuadas fora do
          estabelecimento comercial (pela internet), o consumidor poderá exercer o seu direito de arrependimento e solicitar o
          cancelamento do pedido com reembolso integral no prazo de até <strong>7 (sete) dias corridos</strong>, contados a partir da
          data de confirmação do pagamento.
        </p>
      </section>

      <section>
        <h2>2. Condições Aplicáveis a Produtos Digitais</h2>
        <p>
          Tratando-se de obras digitais (ebooks nos formatos PDF e EPUB), o cancelamento é elegível desde que solicitada a desistência
          dentro do prazo legal de 7 dias. Ao ter o reembolso aprovado e processado:
        </p>
        <ul>
          <li>O direito de acesso à obra (<em>entitlement</em>) será revogado imediatamente na conta do usuário;</li>
          <li>Os links de download e tokens temporários associados ao pedido serão permanentemente invalidados;</li>
          <li>
            O comprador compromete-se a descartar e não manter cópias locais de arquivos eventualmente baixados antes da solicitação,
            em respeito aos direitos autorais do autor e da editora.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Procedimento para Solicitação</h2>
        <p>
          Para solicitar o cancelamento e reembolso, o comprador deverá encaminhar um e-mail para{" "}
          <a href="mailto:contato@datasci.com.br">contato@datasci.com.br</a> informando:
        </p>
        <ul>
          <li>O número do pedido (código no formato <code>ORD-XXXX</code>);</li>
          <li>E-mail cadastrado utilizado no momento da compra;</li>
          <li>Chave Pix ou comprovante de pagamento Pix emitido no ato da compra.</li>
        </ul>
      </section>

      <section>
        <h2>4. Prazo e Forma de Restituição do Valor</h2>
        <p>
          Como todos os pagamentos da Datasci Editora são processados via <strong>Pix</strong> através da integradora bancária{" "}
          <strong>Universal Pagamentos / Celcoin</strong>, a devolução dos valores será realizada:
        </p>
        <ul>
          <li>Exclusivamente na mesma conta bancária de origem que efetuou a transferência Pix;</li>
          <li>
            Em até <strong>3 (três) dias úteis</strong> após a análise e aprovação formal do pedido de reembolso pela equipe
            administrativa;
          </li>
          <li>Sem incidência de taxas de cancelamento ou deduções operacionais.</li>
        </ul>
      </section>

      <section>
        <h2>5. Planos e Contratos Corporativos (B2B)</h2>
        <p>
          O cancelamento ou rescisão de contratos de licenciamento corporativo regem-se pelas cláusulas específicas pactuadas no
          respectivo Instrumento Particular de Licenciamento de Software e Acervo Digital firmado entre a LONDON SIM e a pessoa
          jurídica contratante.
        </p>
      </section>
    </article>
  );
}
